module.exports = __webpack_public_path__ + "685a8802f32d58b9deb537feae557cf7.svg";